export default {
  WILL_PICKUP_TYPE: 1,
  WILL_NOT_PICKUP_TYPE: 2,
}